import React, { memo as Memo, useMemo } from 'react'
import { Form, Input as BaseInput, InputNumber, Checkbox } from 'antd'
import { useRules } from 'helpers'

const Input = Memo(props => {
    const Field = useMemo(() => {
        let field

        switch (props.type) {
            case 'textarea':
                field =
                    <BaseInput.TextArea	{...props.inputOptions} rows={6} className="input-text" placeholder={props.placeholder} />
                break
            case 'number':
                field =
                    <InputNumber {...props.inputOptions} className="input-text" placeholder={props.placeholder} />
                break
            case 'checkbox':
                field =
                    <Checkbox {...props.inputOptions} />
                break
            case 'password':
                field =
                    <BaseInput.Password	{...props.inputOptions} className="input-text" placeholder={props.placeholder} />
                break
            default:
                field =
                    <BaseInput
                        disabled={props.disabled}
                        {...props.inputOptions}
                        className="input-text"
                        placeholder={props.placeholder}
                    />
        }

        return field
    }, [props.type, props.placeholder])

    return (
        <Form.Item
            {...props.labelOptions}
            label={props.label}
            name={props.name}
            className={props.className}
            rules={useRules(props)}
            messageVariables={{ errorKey: props.errorKey || props.label }}>
            {Field}
        </Form.Item>
    )
})

Input.defaultProps = {
    type: '',
    label: '',
    name: '',
    required: true,
    rules: [],
    labelOptions: {},
    inputOptions: {},
    placeholder: '',
    errorKey: null,
    disabled: false
}

export default Input
